import IconTile from '../../Icon/IconTile';

const SquareUsers = () => <IconTile name="users" />;

export { SquareUsers };
